<template>
      <div>
        <h2>Users</h2>
        <router-link :to="'/panel/users/add'">
            <button class="btn btn-primary float-right">Add user <i class="icon icon-cph_iconset_plus"></i></button>
        </router-link>
        <vue-table ref="table" :useSearch="true"
            :dataTable="getUsersIncludingFilters"
            :defaultSortOrder="[getUsersTableSortOrder]"
            :tableFields="usersTableFields"
            :filters="getUsersTableFilters"
            @onSearch="onSearch"
        >
            <template slot="buttons" slot-scope="props">
                <router-link  v-for="(button, index) in buttonTypes" :key="index"
                    :to="`/panel/users/${props.data.id}${button.name ? '/'+button.name : ''}`">
                    <button class="btn icon-btn pr-0 mx-1" 
                        v-if="button.isAllowed">
                        <i class="icon" :class="button.name"></i>
                    </button>
                </router-link>
            </template>
        </vue-table>
      </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Table from '../../../components/Panel/Table/Table';
    import UsersTableFields from '../../../utilities/tablesProperties/UsersTableFields';
    import {RegistrationPerimeter} from '../../../router/perimeters/registrationPerimeter';


    export default {
        name: 'users-table',
        components: {
            'vue-table': Table,
        },
        data() {
            return {
                usersTableFields: UsersTableFields,
                // buttonTypes: ['edit', 'shops', 'showUsers', 'remove'],
                buttonTypes: [
                    { name: 'edit', isAllowed: true  },
                    { name: 'shops', isAllowed: true },
                    { name: 'showUsers', isAllowed: true  },
                    { name: 'remove', isAllowed: true }
                ]
            }
        },
        watch: {
            getUsers(oldVal, newVal) {
                this.SetUsersIncludingFilters(oldVal);
            }
        },
        computed: {
            ...mapGetters({
                getUsers: 'getUsers',
                getUsersTableSortOrder: 'getUsersTableSortOrder',
                getUsersTableFilters: 'getUsersTableFilters',
                getUsersIncludingFilters: 'getUsersIncludingFilters'
            })
        },
        methods: {
            ...mapActions([
                'AddUsersTableFilters',
                'SetUsersIncludingFilters'
            ]),
            onSearch(data) {
                this.AddUsersTableFilters(data);
                this.SetUsersIncludingFilters(this.getUsers);
            },
        }
    }
</script>

<style lang="scss">
    h2 {
        margin-top: 50px;
    }
    i.icon {
        font-style: normal;
        &.edit::before {
            content: "\E938";
        }
        &.shops::before {
            content: "\E917";
        }
        &.addUser::before {
            content: "\E954";
        }
        &.showUsers::before {
            content: "\E91D";
        }
        &.remove::before {
            content: "\E955";
        }
    }
</style>
